var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('labels.loginOut')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }